import {BrowserStore} from '../stores/browser.store';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {BrowserState} from '../modules/akita-mimic/models/store-states/browser-state.model';

@Injectable({ providedIn: 'root' })
export class BrowserQuery extends QueryService<BrowserState> {
    public hasSmallViewport$: Observable<boolean> = this.select('hasSmallViewport');

    public constructor() {
        const store = inject(BrowserStore);
        super(store);
    }

    public hasSmallViewport(): boolean {
        return this.getValue().hasSmallViewport;
    }
}
